/**
 * Created by User on 10/5/2016.
 */
import PageComponent from '../base/PageComponent';
import 'slick-carousel';

export default class ProductSearchForm extends PageComponent {
    constructor(element) {
        super(element);
    }

    init(){
        this.element.on('submit', e => this.search(e));

        this.setupCarousel();
    }

    search(e){
        e.preventDefault();
        let page = this.element.closest('.product-page'),
            headers = new Headers(),
            url = this.element.attr('action') +
                '?OuterDiameter=' + $('#Form_ProductSearchForm_OuterDiameter').val() +
                '&FilterLength=' + $('#Form_ProductSearchForm_FilterLength').val(),
            self = this;

        headers.append("X-Requested-With", "XMLHttpRequest");

        fetch(url, {
            method: 'GET',
            headers: headers,
        }).then(response => {
            return response.json();
        }).then(json => {
            page.find('.productResults').html(json.Content);
            self.setupCarousel();
        });
    }

    setupCarousel() {
        let images = this.element.closest('.product-page').find('.product__imgs');
        images.each(function(){
            $(this).slick({
                slide: '.product__img',
                autoplay: false,
                adaptiveHeight: false,
                dots: true,
                speed: 1,
                appendDots: $(this),
                customPaging: function (slider, i) {
                    var thumb = $(slider.$slides[i]).data('thumb');
                    return '<span></span>';
                },
                slidesToShow: 1,
                infinite: false,
                arrows: false
            });
        });

        $('.slick-dots').on('click', e => this.carouselChange(e));
    }

    carouselChange(e){
        $('.zoomContainer').remove();
        $('#elevate-zoomr').removeData('elevateZoom');
    }
}


// WEBPACK FOOTER //
// ./src/js/components/ProductSearchForm.js